import { IconHighway16, ArticleParagraph1 } from '@cian/ui-kit';
import React from 'react';

import * as styles from './Highway.css';
import { IOfferHighway } from '../../../types/offers';

export interface IHighwaysProps {
  highway: IOfferHighway;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export function Highway({ highway, onClick }: IHighwaysProps) {
  const { name, distance, qs } = highway;

  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <IconHighway16 display="block" />
      </div>
      <span className={styles['name']}>
        {qs ? (
          <a href={qs} className={styles['link']} target="_blank" rel="noopener noreferrer" onClick={onClick}>
            <ArticleParagraph1>{`${name} шоссе${distance ? ', ' : ''}`}</ArticleParagraph1>
          </a>
        ) : (
          <ArticleParagraph1>{`${name} шоссе${distance ? ', ' : ''}`}</ArticleParagraph1>
        )}
      </span>
      {distance && <ArticleParagraph1 display="inline">{`${Math.round(distance)} км от МКАД`}</ArticleParagraph1>}
    </div>
  );
}
